import { User } from 'lib-shared-types-api';
import { PureComponent } from 'react';

import { MessageStatus } from '../messageStatus';
type StatusClosedProps = {
  /** The message object */
  message: any;
  /** Is own */
  own: boolean;
};

export default class StatusClosed extends PureComponent<StatusClosedProps> {
  constructor(props: StatusClosedProps) {
    super(props);
  }

  generateStatusText(own: boolean, author: User) {
    if (own) {
      return 'You have closed this conversation';
    }

    const { name, phone_number, email } = author;
    const text = 'Conversation was closed';

    if (name && name.trim().length) {
      return `${text} by ${name}`;
    }
    if (phone_number || email) {
      return `${text} by ${phone_number || email}`;
    }
    return text;
  }

  render() {
    const { message, own, ...otherProps } = this.props;

    return (
      <MessageStatus
        {...(otherProps as any)}
        text={this.generateStatusText(own, message.author)}
      />
    );
  }
}
